import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MessageOutlined } from "@ant-design/icons";
import { theme } from "antd";
import { __, _i } from "../../../../utils/i18n.js";
import { getLegalManufacturerUrls } from "../../../../utils/legalEntities.js";
const externalLinkProps = {
    target: "_blank",
    rel: "noopener noreferrer"
};
/**
 * "Questions getting started?" block. Rendered as a soft-bg card with a
 * prominent icon so a buyer who does run into a problem recognises it as an
 * active help invitation, not a footer afterthought.
 */ const SupportSection = ({ productName })=>{
    const { token } = theme.useToken();
    const manufacturer = getLegalManufacturerUrls();
    return /*#__PURE__*/ _jsxs("div", {
        className: "checkout-v2-success__support",
        style: {
            background: token.colorBgLayout,
            color: token.colorTextHeading
        },
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "checkout-v2-success__support-icon",
                style: {
                    background: token.colorPrimary,
                    color: "#ffffff"
                },
                children: /*#__PURE__*/ _jsx(MessageOutlined, {
                    "aria-hidden": true
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "checkout-v2-success__support-body",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "checkout-v2-success__support-title",
                        children: __("Questions getting started?")
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        children: _i(__("If you need help installing, activating or using %s, our support team is happy to help. {{a}}Open a support ticket{{/a}} any time.", productName), {
                            a: /*#__PURE__*/ _jsx("a", {
                                href: manufacturer.support,
                                ...externalLinkProps
                            })
                        })
                    })
                ]
            })
        ]
    });
};
export { SupportSection };
